import { Pagination, SelectItem } from '~/types';
import { CargaSAP, CargaSAPEmpresas } from '~/types/cargaSAP';
import api from '~/utils/api';

// export async function listEmpresasCargaSAP(): Promise<CargaSAPEmpresas[]> {
//   const { data } = await api.get<CargaSAPEmpresas[]>('/json', {
//     params: {},
//   });
//   console.log(data);
//   return data;
// }

export async function listCompaniesCargaSAP(): Promise<SelectItem[]> {
  const responses: SelectItem[] = [];

  return new Promise((resolve, rejects) => {
    async function getData(page: number) {
      return api
        .get<Pagination<CargaSAPEmpresas>>('/json', {
          params: {
            page,
            size: 1000,
          },
        })
        .then(response => {
          const options = response.data.results.map(company => ({
            label:
              `${company.cd_usuariosap} - ${company.nm_razaosocial}` || '-',
            value: String(company.id_json),
          }));
          responses.push(...options);

          if (response?.data.next) {
            getData(page + 1);
            return response;
          }
          return resolve(responses);
        })
        .catch(() => {
          return rejects(responses);
        });
    }
    getData(1);
  });
}

export async function getCargaSAP(id: string): Promise<CargaSAP> {
  let id_tofind = id;
  if (id === '0' || id === '') id_tofind = '1';
  const { data } = await api.get<CargaSAP>(`/json/${id_tofind}`, {
    params: {},
  });
  console.log(data);
  return data;
}
